class customAddress extends HTMLElement {
  constructor() {
      super();
      this.editBtn = this.querySelectorAll('.body-address__buttons-edit');

      this.editBtnToggle = this.editBtnToggle.bind(this);
  }

  connectedCallback() {
      this.editBtn.forEach(button => {
          button.addEventListener("click", this.editBtnToggle);
      });
  }

  editBtnToggle(e) {
      e.preventDefault();
      var editContainer = e.currentTarget.closest(".body-address__item");
      if (!editContainer) return;
      var slideEdit = editContainer.querySelector(".body-address__edit");
      if (!slideEdit) return;
      slideEdit.classList.toggle("body-address__edit--visible");
  }
}

customElements.define("custom-address", customAddress);

class SidebarNavigation extends HTMLElement {
    constructor() {
        super();
        this.updateActiveLink = this.updateActiveLink.bind(this);
    }

    connectedCallback() {
        this.updateActiveLink();
        window.addEventListener('hashchange', this.updateActiveLink);
    }

    disconnectedCallback() {
        window.removeEventListener('hashchange', this.updateActiveLink);
    }

    updateActiveLink() {
        this.querySelectorAll('.sidebar-link').forEach(function(link) {
            link.classList.remove('sidebar-link--active');
        });
        
        const currentHash = window.location.hash;
        
        if (currentHash) {
            const activeLink = this.querySelector(`a.sidebar-link[href="${currentHash}"]`);
            if (activeLink) {
                activeLink.classList.add('sidebar-link--active');
            }
        } else {
            const accountLink = this.querySelector('a.sidebar-link[href="#account"]');
            if (accountLink) {
                accountLink.classList.add('sidebar-link--active');
            }
        }
    }
}

customElements.define('sidebar-navigation', SidebarNavigation);